import React from 'react';

import Spinner from '@atlaskit/spinner/spinner';

import { LoadableLazy } from '@confluence/loadable';
import { expVal } from '@confluence/feature-experiments';

import { LazyCommentEditorPlaceholder } from './LazyCommentEditorPlaceholder.tsx';

export const LazyCommentEditor = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-CommentEditor" */ './CommentEditor.tsx'))
			.CommentEditor,
	loading: () => (
		<div>
			<Spinner size="medium" interactionName="comment-editor-loadable" />
		</div>
	),
	waitForNetworkOnline: () => expVal('platform_editor_offline_editing_web', 'isEnabled', false),
});

export const LazyInlineCommentEditor = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-CommentEditor" */ './CommentEditor.tsx'))
			.CommentEditor,
	loading: () => <LazyCommentEditorPlaceholder />,
	waitForNetworkOnline: () => expVal('platform_editor_offline_editing_web', 'isEnabled', false),
});

export const LazyCommentEditorWithoutSpinner = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-CommentEditor" */ './CommentEditor.tsx'))
			.CommentEditor,
	waitForNetworkOnline: () => expVal('platform_editor_offline_editing_web', 'isEnabled', false),
});
